import { accent } from "../hooks/tokens.js";
import { TREES, ARTICLES } from "../data.js";

// Arbres de décision de dépannage : question courante, chemin parcouru,
// verdict final le cas échéant. Purement dérivé de s.treeId/s.treePath.
export function buildTshootView(ctx) {
  const { s, patch, go } = ctx;

  const treeNode = () => {
    const tree = TREES.find((t) => t.id === s.treeId) || TREES[0];
    let node = tree.nodes[tree.root];
    s.treePath.forEach((step) => { node = tree.nodes[step.next] || node; });
    return { tree, node };
  };

  return {
    treeTabs: TREES.map((t) => ({ label: t.label,
      border: t.id === s.treeId ? accent : "oklch(0.92 0.008 85)",
      color: t.id === s.treeId ? accent : "oklch(0.45 0.015 60)",
      bg: t.id === s.treeId ? "oklch(0.99 0.006 60)" : "transparent",
      onClick: () => patch({ treeId: t.id, treePath: [] }) })),
    treeTrail: s.treePath.map((step, i) => ({ n: String(i + 1), question: step.q, answer: step.label })),
    ...(() => {
      const { tree, node } = treeNode();
      const target = node.article ? ARTICLES.find((a) => a.id === node.article) : null;
      return {
        treeAsking: !!node.options, treeDone: !!node.verdict,
        treeStepLabel: "Étape " + (s.treePath.length + 1),
        treeQuestion: node.q || "", treeHasCheck: !!node.check, treeCheck: node.check || "",
        treeOptions: (node.options || []).map((o) => ({ label: o.label,
          onClick: () => patch({ treePath: [...s.treePath, { q: node.q, label: o.label, next: o.next }] }) })),
        treeVerdict: node.verdict || "", treeFix: node.fix || "", treeCommand: node.command || "",
        treeArticleTitle: target ? target.title : "",
        treeArticle: () => { if (target) go(target.id); },
        resetTree: () => patch({ treePath: [] }),
        treeProgress: node.verdict
          ? "Diagnostic atteint en " + s.treePath.length + " question" + (s.treePath.length > 1 ? "s" : "") + "."
          : s.treePath.length + " réponse" + (s.treePath.length > 1 ? "s" : "") + " sur « " + tree.label.toLowerCase() + " ». Chaque étape propose la commande à lancer avant de répondre.",
      };
    })(),
  };
}
